import { useLocation } from "react-router-dom";
import { Row, Col, Button, Container } from "react-bootstrap";

import "./BlogDetails.css";

function BlogDetails() {
  const location = useLocation();
  const blog = location.state?.blog; 
  

  if (!blog) {
    return <h1>No Blog Data Found</h1>;
  }

  return (
    <Container>
      <div className="blog-details">
        <img src={blog.image} alt="Blog" className="img-fluid w-100" />

        <h1 className="blog-details-title">{blog.title}</h1>
        <p className="author-details-name">
           {blog.author_name}
        </p>
        <p>
          {blog.created_at}
        </p>
        <p className="blog-details-content">{blog.content}</p>

      </div>
    </Container>
  );
}

export default BlogDetails;
